import { render, staticRenderFns } from "./LotBuyersPremiumTaxRate.vue?vue&type=template&id=4260925c&scoped=true&"
import script from "./LotBuyersPremiumTaxRate.vue?vue&type=script&lang=js&"
export * from "./LotBuyersPremiumTaxRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4260925c",
  null
  
)

export default component.exports